import React from "react";

const ReportAccounts = () => {
  return <div>ReportAccounts</div>;
};

export default ReportAccounts;
